<form [formGroup]="alarmMasksForm">
  <div class="mb-4">
    <h2>
      <button
        type="button"
        class="flex items-center justify-between w-full py-5 font-medium rtl:text-right text-gray-700 border-b border-gray-200 gap-3 relative cursor-pointer"
        (click)="toggleAlarmVisibility()"
        appAgentAction
        agent="alarm-mask-view-toggle"
        action="toggle"
        businessObject="alarm-mask"
      >
        <span>Alarm Masks on Terminal</span>
        <span
          class="ml-2.5 inline-block size-2.5 shrink-0 rounded-full absolute right-10"
          [ngClass]="commonUtils.translationStateToColor(maskTranslationState)"
          title="{{ commonUtils.friendlyTranslationState(maskTranslationState) }}"
        >
        </span>
        <svg
          [ngClass]="isAlarmVisible ? '' : 'rotate-180'"
          class="w-5 h-5 shrink-0 transition-transform duration-200 ease-in-out"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="m5 15 7-7 7 7"
          />
        </svg>
      </button>
    </h2>
    <div
      class="transition-all duration-400 ease-in-out"
      [ngClass]="{ 'max-h-[40rem] overflow-y-auto': isAlarmVisible, 'max-h-0 overflow-hidden': !isAlarmVisible }"
    >
      <div class="py-5 border-b border-gray-200">
        <div class="mb-4 font-light text-gray-500 sm:mb-5">
          @if (alarmMask) {
            <app-selection
              [formControl]="currentAlarmMaskId"
              [options]="alarmMaskOptions"
              [fullWidth]="true"
            ></app-selection>
            <div>
              <app-alarm-mask-content [alarmMask]="alarmMask"></app-alarm-mask-content>
            </div>
          } @else {
            <p class="text-body text-amazone-orange font-xs italic">
              <span class="p-2">No alarm mask available for this terminal.</span>
            </p>
          }
        </div>
      </div>
    </div>
  </div>
</form>
